export type ToolName =
  | "GitHub"
  | "Supabase"
  | "Cloudflare"
  | "OpenAI"
  | "Gemini"
  | "Claude"
  | "Stripe"
  | "Google Workspace"
  | "Calendar";
export type ToolHealth = "healthy" | "degraded" | "unhealthy" | "unknown";

export type ToolRegistration = {
  name: ToolName;
  enabled: boolean;
  connected: boolean;
  health: ToolHealth;
  permissions: string[];
  environment: "development" | "staging" | "production";
  cost: "free" | "metered" | "unknown";
  owner: string;
  lastUse: string | null;
  executionPolicies: string[];
};

export class ToolRegistry {
  private readonly tools = new Map<ToolName, ToolRegistration>();

  register(tool: ToolRegistration): void {
    this.tools.set(tool.name, tool);
  }

  list(): ToolRegistration[] {
    return [...this.tools.values()];
  }

  get(name: ToolName): ToolRegistration | undefined {
    return this.tools.get(name);
  }
}

export function createDefaultToolRegistry(
  environment: ToolRegistration["environment"],
): ToolRegistry {
  const registry = new ToolRegistry();
  for (const name of [
    "GitHub",
    "Supabase",
    "Cloudflare",
    "OpenAI",
    "Gemini",
    "Claude",
    "Stripe",
    "Google Workspace",
    "Calendar",
  ] as ToolName[]) {
    registry.register({
      name,
      enabled: false,
      connected: false,
      health: "unknown",
      permissions: [],
      environment,
      cost: "unknown",
      owner: "SS Core",
      lastUse: null,
      executionPolicies: ["disabled_until_configured"],
    });
  }
  return registry;
}
